export enum StatusOptions {
  Available = 'success',
  Unavailable = 'danger',
  Unknown = 'gray-text',
}
